import { Toolbar } from '@mui/material'
import React, { useState } from 'react'
import { DashboardHead } from '../../Dashboard/DashboardPage'
import { DataTable, FilterSection, SelectField, ToolbarComponent } from '../../../../../components'
import { vanListHeadCells } from '../../../../../shared/data/headCells'
import { VanForms } from './components/VanForms'
import { VanListDetails } from './components/VanListDetails'
import { useGlobal } from '../../../../../shared'
import { urls } from '../../../../../shared/config'
import { InfoField } from '../School/PopOver/SchoolInfo'
import { highestInt } from '../../../../../shared/utils/constants'
import { useSelector } from 'react-redux'
import { ExportIcon } from '../../../../../assets/icons'
// import { useSelector } from 'react-redux'

export const VanList = () => {
  const userSchoolId = localStorage.getItem('userSchoolId')
  const storedAttributes = localStorage.getItem('userAttributes')
  const rowsPerPage = useSelector((state) => state.global.rowsPerPage)

  const attributes = JSON.parse(storedAttributes)
  const customRole = attributes?.employee_type
  const [schoolName, setSchoolName] = React.useState('')
  const [driverForm, setDriverForm] = useState(false)
  const [update, setUpdate] = React.useState(false)
  const [search, setSearch] = useState('')
  const [detail, setDetailOpen] = useState(false)
  // const [passengerForm, setPassengerForm] = useState(false)
  const [page, setPage] = React.useState(1)

  // const openSection = useSelector((state) => state.global.openSection)
  const { data: vanData, count ,refetch} = useGlobal({
    // userUrl: `${urls.VAN_GET}${customRole == 'Admin' || customRole === 'Superadmin' ? userSchoolId : ''}`,
    userUrl: `${urls.VAN_GET}${schoolName ? schoolName : userSchoolId}&page=${page}&limit=${rowsPerPage}&keyword=${search}`,
  })
  // console.log(vanData)
  const { data: schoolList } = useGlobal({
    userUrl: `${urls.SCHOOL_LIST}?page=1&limit=${highestInt}`,
  })
  const userSchoolName = schoolList?.find((school) => school.school_id == userSchoolId)?.school_name
  // const { data: searchVan } = useGlobal({
  //   userUrl: `${urls.VAN_SEARCH}${customRole == 'Admin' || customRole === 'Superadmin' ? userSchoolId : ''}&keyword=${search}`,
  // })
  const no_data_msg =
    customRole == 'Admin'
      ? 'Add Van to start over'
      : schoolName
        ? 'Add van to start over'
        : 'Select school to see Vans'
  const rowData = vanData || []

  // const handlePassengerOpen = () => {
  //   setPassengerForm(true)
  // }
  const handleClose = () => {
    if (update) {
      setUpdate(false)
    } else {
      setDriverForm(false)
    }
  }
  const handleExport = () => {
    if (rowData && rowData.length > 0) {
      // Generate filename with school name
      let filename = 'Van_List'

      if (schoolName) {
        const school = schoolList?.find((s) => s.school_id === schoolName)
        if (school) {
          filename += `_${school.school_name.replace(/\s+/g, '_')}`
        }
      } else if (customRole === 'Admin' && userSchoolName) {
        filename += `_${userSchoolName.replace(/\s+/g, '_')}`
      }

      // Add current date
      const date = new Date().toISOString().split('T')[0]
      filename += `_${date}`

      // Export the data
      downloadCSV(rowData, filename)
      toast.success(`${rowData.length} van records exported`)
    } else {
      toast.error('No data to export')
    }
  }

  return (
    <div>
      <Toolbar />
      <DashboardHead title={'Van List'} subtitle={'Van / Van List'} />
      <div className="school-toolbar">
        <div style={{ width: '40%' }}>
          {customRole != 'Admin' ? (
            <SelectField
              placeholder={'Select School'}
              options={(schoolList || [])?.map((prod) => ({
                value: prod.school_id,
                label: prod.school_name,
              }))}
              name="schoolName"
              value={schoolName}
              onChange={(selectedOption) => {
                setSchoolName(selectedOption)
                setPage(1)
              }}
            />
          ) : (
            <InfoField value={userSchoolName} />
          )}
        </div>
        <ToolbarComponent
          classView
          handleOpen={() => setDriverForm(true)}
          search={search}
          setSearchItem={setSearch}
          setPage={setPage}
        >
          {/* <FilterSection icon={FilterIcon} title={'Filter'} />
        
        <FilterSection icon={ImportIcon} title={'Import CSV'} /> */}
          <FilterSection icon={ExportIcon} onClick={handleExport} title={'Export'} />
        </ToolbarComponent>
      </div>
      <DataTable
        // rowData={rowData}
        rowData={vanData}
        vanList
        headCells={vanListHeadCells}
        handleDetailOpen={() => setDetailOpen(true)}
        pageFee={page}
        school={false}
        pageCount={count}
        noDataMsg={no_data_msg}
        setPageFee={setPage}
        setUpdate={setUpdate}
        pages
        refetch={refetch}
      />
      {(driverForm || update) && (
        <VanForms
          open={driverForm || update}
          handleClose={handleClose}
          customRole={customRole}
          userSchoolId={userSchoolId}
          update={update}
          refetch={refetch}
        />
      )}
      {detail && (
        <VanListDetails
          open={detail}
          // handlePassengerOpen={handlePassengerOpen}
          handleClose={() => setDetailOpen(false)}
        />
      )}
      {/* {passengerForm && (
        <PassengerForm open={passengerForm} handleClose={() => setPassengerForm(false)} />
      )} */}
    </div>
  )
}
